export default "__VITE_ASSET__C$B3K0J6__"